/**
 * TaskAttachmentService
 * Service for TaskAttachment entity operations
 * Route: api/task-attachment
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskAttachmentService
 * Handles task attachment CRUD operations and attachment views
 */
export class TaskAttachmentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskAttachmentService.DEFAULT_SERVICE_PATH,
            basePath: TaskAttachmentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL VIEWS ====================
    /**
     * Get all attachment views
     * GET api/task-attachment/view
     */
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all attachment views with full response
     */
    getAllViewsRaw() {
        const endpoint = this.getEndpoint('all-views', 'view');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY TASK ID ====================
    /**
     * Get all attachments for a task
     * GET api/task-attachment/task/{taskId}
     */
    async getByTaskId(taskId) {
        const response = await this.getByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get all attachments for a task with full response
     */
    getByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('by-task', `task/${taskId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEWS BY TASK ID ====================
    /**
     * Get attachment views for a task
     * GET api/task-attachment/task/{taskId}/view
     */
    async getViewsByTaskId(taskId) {
        const response = await this.getViewsByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get attachment views for a task with full response
     */
    getViewsByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('views-by-task', `task/${taskId}/view`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEW BY ID ====================
    /**
     * Get attachment view by ID
     * GET api/task-attachment/view/{id}
     */
    async getViewById(id) {
        const response = await this.getViewByIdRaw(id);
        if (!response.data) {
            throw new Error(`Attachment view ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get attachment view by ID with full response
     */
    getViewByIdRaw(id) {
        const endpoint = this.getEndpoint('view-by-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TaskAttachmentService.DEFAULT_SERVICE_PATH = 'tasks';
TaskAttachmentService.BASE_PATH = 'api/task-attachment';
//# sourceMappingURL=TaskAttachmentService.js.map